/* ml-ingredientes-venta.js · la venta del lector de INCI, /pages/leerinci
   ----------------------------------------------------------------------
   Lo carga sections/ml-ingredientes.liquid SOLO en la venta —sin sesión, o
   con sesión y sin el curso—. El lector tiene su propio guion
   (ml-ingredientes.js), que en la venta no viaja. Es la maqueta 15
   (maquetas/15-venta-lector-inci.html), del 10/10/2026.

   Sin este guion la página se lee entera: las tres demostraciones, una
   debajo de otra, y sin barra de compra. Este guion hace tres cosas: las
   dos de abajo y, desde el 10/10/2026, EL AVISO DEL LECTOR, que va en
   medio y se cuenta allí.

   1 · LAS PESTAÑAS DE LA DEMOSTRACIÓN. El patrón de pestañas de la WAI:
   la lista con role="tablist", la pestaña elegida con tabindex 0 y las
   demás con -1, y las flechas, Inicio y Fin para moverse, que eligen al
   moverse. Si el panel que se esconde tenía el foco —quien hace clic en
   Safari no lo pasa al botón—, se lleva antes a su pestaña: es la regla
   de la casa de no esconder el elemento enfocado (N30). Lo vigila N85.

   2 · LA BARRA DE COMPRA DEL MÓVIL. Se enciende cuando ningún botón de
   compra de la página queda a la vista por debajo de la cabecera pegada y
   ya se ha pasado el primero; se apaga en cuanto vuelve uno. Así nunca hay
   dos sitios donde comprar a la vez, ni ninguno. Tres reglas de la casa:
   · EL RELEVO ES EN EL TECHO, no en el borde de la ventana: un botón
     tapado por la cabecera pegada ya no contesta al dedo. El techo es
     --ml-techo (assets/ml-base.css), y se lee en cada medida porque cambia
     cuando la cabecera se pega o se suelta (N54).
   · LA CONDICIÓN SE MIDE EN CADA DESPLAZAMIENTO, y no con un
     IntersectionObserver: un observador con el margen del techo de un
     momento vigila una línea que luego se mueve, y la barra se quedaba
     encendida con un botón a la vista (lo que costó media tarde en las
     fichas). El oyente va en captura sobre el documento porque desde
     990 px no se desplaza el documento sino DIV.page-wrapper.
   · SI LA BARRA TIENE EL FOCO CUANDO SE APAGA, el foco se lleva antes al
     botón que la releva (N30, N34).
   Lo vigila N86. */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-ml-venta]');
  if (!raiz) return;

  // ── 1 · Las pestañas ──
  var lista = raiz.querySelector('[data-ml-venta-pestanas]');
  var tabs = lista ? [].slice.call(lista.querySelectorAll('[role="tab"]')) : [];
  var paneles = [].slice.call(raiz.querySelectorAll('[data-ml-venta-panel]'));

  function elegir(tab, foco) {
    var panel = document.getElementById(tab.getAttribute('aria-controls'));
    paneles.forEach(function (p) {
      if (p !== panel && p.contains(document.activeElement)) tab.focus();
    });
    tabs.forEach(function (x) {
      var si = x === tab;
      x.setAttribute('aria-selected', String(si));
      x.tabIndex = si ? 0 : -1;
    });
    paneles.forEach(function (p) { p.hidden = p !== panel; });
    if (foco) tab.focus();
  }

  if (lista && tabs.length && paneles.length) {
    lista.hidden = false;
    var inicial = tabs.filter(function (x) { return x.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    elegir(inicial, false);
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { elegir(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j === null) return;
        e.preventDefault();
        elegir(tabs[j], true);
      });
    });
  }

  /* ── EL AVISO DEL LECTOR ──
     La opción A de maquetas/17, del 10/10/2026: con «Próximamente» y el id
     del formulario, el Liquid pinta dos botones —bajo la compra y en la
     primera pregunta— y este guion abre con ellos el pop-up de Klaviyo con
     su función oficial, openForm, como la landing B. La suscripción la hace
     el formulario, con su lista: aquí no se llama a ninguna API.
     · AL ENVIAR, LOS DOS SITIOS DICEN «ANOTADO». Klaviyo avisa en WINDOW con
       «klaviyoForms», y solo cuenta el envío de NUESTRO formulario.
     · AL CERRAR EL POP-UP, EL FOCO VUELVE a donde se pulsó: al botón, o a
       su «Anotado» si se envió, porque el botón ya no está y un foco que
       Klaviyo devuelve a un botón escondido cae al <body> (N30). Se mira en
       dos tiempos porque no sabemos cuándo suelta Klaviyo el suyo, y solo
       si el foco anda perdido: si la clienta ya lo ha puesto en otro sitio,
       no se le quita.
     · LA MEMORIA, como la landing B: en la visita, siempre; entre visitas,
       solo con el consentimiento de PREFERENCIAS de Shopify, cuya API llega
       tarde —en «load», medido el 10/10/2026— y se pide con loadFeatures.
     Lo vigila N87. */
  var formulario = raiz.getAttribute('data-ml-venta-aviso') || '';
  var cajas = [].slice.call(raiz.querySelectorAll('[data-ml-venta-avisa]'));
  if (formulario && cajas.length) avisoDelLector(formulario, cajas);

  function avisoDelLector(formulario, cajas) {
    var CLAVE = 'ml-lector-aviso';
    var desde = null;
    var enviado = false;
    var porGuardar = false;

    function hayApi() { return !!(window.Shopify && window.Shopify.customerPrivacy); }
    function preferencias() {
      try {
        var p = window.Shopify && window.Shopify.customerPrivacy;
        if (!p || typeof p.preferencesProcessingAllowed !== 'function') return false;
        return p.preferencesProcessingAllowed() === true;
      } catch (e) { return false; }
    }
    function recordar() {
      if (!hayApi()) { porGuardar = true; return; }
      if (!preferencias()) return;
      try { window.localStorage.setItem(CLAVE, 'enviado'); } catch (e) { /* sin memoria */ }
    }
    function recordado() {
      if (!preferencias()) return false;
      try { return window.localStorage.getItem(CLAVE) === 'enviado'; } catch (e) { return false; }
    }

    /* Si el foco estaba en lo que se esconde, va antes a su «Anotado». */
    function anotar() {
      enviado = true;
      cajas.forEach(function (caja) {
        var hecho = caja.querySelector('[data-ml-venta-hecho]');
        if (!hecho) return;
        hecho.hidden = false;
        if (caja.contains(document.activeElement) && document.activeElement !== hecho) hecho.focus();
      });
      [].slice.call(raiz.querySelectorAll('[data-ml-venta-pedir]')).forEach(function (x) { x.hidden = true; });
    }
    function leerMemoria() { if (!enviado && recordado()) anotar(); }

    leerMemoria();
    if (!hayApi()) {
      try {
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
            if (error) return;
            leerMemoria();
            if (porGuardar) recordar();
          });
        }
      } catch (e) { /* sin memoria entre visitas */ }
    }

    cajas.forEach(function (caja) {
      var boton = caja.querySelector('[data-ml-venta-avisame]');
      if (!boton) return;
      boton.addEventListener('click', function () {
        desde = caja;
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formulario]);
      });
    });

    function devolverFoco(caja) {
      var a = document.activeElement;
      if (a && a !== document.body && a.getClientRects().length) return;
      var destino = caja.querySelector(enviado ? '[data-ml-venta-hecho]' : '[data-ml-venta-avisame]');
      if (destino) destino.focus();
    }
    window.addEventListener('klaviyoForms', function (e) {
      var d = e && e.detail;
      if (!d) return;
      if (String(d.formId) !== String(formulario)) return;
      if (d.type === 'submit') {
        anotar();
        recordar();
        return;
      }
      if (d.type !== 'close') return;
      var caja = desde;
      desde = null;
      if (!caja) return;
      window.setTimeout(function () { devolverFoco(caja); }, 0);
      window.setTimeout(function () { devolverFoco(caja); }, 500);
    });
  }

  // ── 2 · La barra de compra del móvil ──
  var barra = raiz.querySelector('[data-ml-venta-barra]');
  var botones = [].slice.call(raiz.querySelectorAll('a.ml-ing__boton'));
  if (!barra || !botones.length) return;

  function techo() {
    var v = parseFloat(getComputedStyle(barra).getPropertyValue('--ml-techo'));
    return isNaN(v) ? 0 : v;
  }
  /* Un botón está a la vista si se pinta y alguna parte suya queda entre
     el techo y el borde de abajo de la ventana. */
  function aLaVista(b, arriba) {
    if (!b.getClientRects().length) return false;
    var r = b.getBoundingClientRect();
    return r.bottom > arriba && r.top < window.innerHeight;
  }

  var pendiente = false;
  function medir() {
    pendiente = false;
    var arriba = techo();
    var visibles = botones.filter(function (b) { return aLaVista(b, arriba); });
    var pasado = botones[0].getBoundingClientRect().bottom <= arriba;
    var encender = !visibles.length && pasado;
    if (encender === !barra.hidden) return;
    if (!encender && barra.contains(document.activeElement)) visibles[0].focus();
    barra.hidden = !encender;
  }
  function pedir() {
    if (pendiente) return;
    pendiente = true;
    window.requestAnimationFrame(medir);
  }
  document.addEventListener('scroll', pedir, { capture: true, passive: true });
  window.addEventListener('resize', pedir);
  medir();

  window.mlIngredientesVenta = { version: 1 };
})();
